import React from 'react'
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, withStyles } from '@material-ui/core'
import { ModelDoc } from '../docs_model'
import langEnum from '../../../../../enums/langEnum'
import classNames from 'classnames'
import { IntlShape, useIntl } from 'react-intl'
import makeStyles from '@material-ui/core/styles/makeStyles'
import styles from '../../../../../styles'
import DocPdf from './DocPdf'

const useStyle = makeStyles((theme) => ({
		...styles(theme),
		nameItem: {
			paddingLeft: '3%'
		},
		tableDocs: {
			width: '100%',
			margin: '2% 0px'
		},
		iconPdf: {
			fill: theme.palette.accessibility.main
		}
	}
))

const StyledTableCell = withStyles((theme) => ({
		root: {
			padding: '3% 0px',
			color: theme.palette.blue['50']
		},
		body: {
			borderBottom: 'none',
			borderTop: `1px solid ${theme.palette.blue['10']}`
		}
	}
))(TableCell)

interface AcceptingProps {
	docs: Array<ModelDoc>

}

type TableDocProps = AcceptingProps

const TableDoc: React.FC<TableDocProps> = (
	{
		docs
	}
) => {
	const classes = useStyle()
	const intl: IntlShape = useIntl()

	const column1: string = intl.formatMessage({ id: 'contracts.document.date', defaultMessage: 'Date', description: 'column Date' })
	const column2: string = intl.formatMessage({ id: 'contracts.document.name', defaultMessage: 'Nom', description: 'column Name' })
	const column3: string = intl.formatMessage({ id: 'contracts.document.ddl', defaultMessage: 'Téléchargement', description: 'column ddl' })

	const textItem = classNames(
		classes.text2,
		classes.medium
	)

	const nameItem = classNames(
		classes.text2,
		classes.medium,
		classes.nameItem
	)

	const docTypeClass = classNames(
		classes.colorBlue,
		classes.semiBold
	)

	return (
		<TableContainer>
			<Table className={classes.tableDocs}>
				<TableHead>
					<TableRow>
						<StyledTableCell className={textItem}>{column1}</StyledTableCell>
						<StyledTableCell className={nameItem}>{column2}</StyledTableCell>
						<StyledTableCell className={textItem} align="right">{column3}</StyledTableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{docs.map((doc: ModelDoc, key) => (
						<TableRow key={key}>
							<StyledTableCell className={textItem}>
								{doc.dwstoredatetime.toLocaleDateString()}
							</StyledTableCell>
							<StyledTableCell className={nameItem}>
								<span className={docTypeClass}>{(intl.locale === langEnum.fr) ? doc.renommage_fr : doc.renommage_en}</span> - {doc.titre_object}
							</StyledTableCell>
							<StyledTableCell className={textItem} align="right">
								<DocPdf doc={doc} />
							</StyledTableCell>
						</TableRow>
					))}
				</TableBody>
			</Table>
		</TableContainer>
	)
}
export default TableDoc